(function () {
    'use strict';

    angular.module('asys')
        .controller('EinstiegController', EinstiegController);

    EinstiegController.$inject = [
        '$log',
        '$element',
        '$stateParams',
        '$modal',
        '$analytics',
        'lodash',
        'angebotModel',
        'AppConfig',
        'BasisAngebotService',
        'NavigationService',
        'MiscUtilsService',
        'AlertService',
        'ExceptionHandlerService',
        'IntegrationService',
        'LoadingIndicatorService'
    ];
    function EinstiegController($log, $element, $stateParams, $modal, $analytics, _, angebotModel, AppConfig, BasisAngebotService, NavigationService, MiscUtilsService, AlertService, ExceptionHandlerService, IntegrationService, LoadingIndicatorService) {
        var vm = this,
            AngebotSpezifischService;

        activate();

        function activate() {
            var wkz = _.get(angebotModel, 'angebot.angebotsgegenstandFahrzeug.wkz.wert'),
                wkzUrlMapping = _.get(AppConfig.APP.wkzUrlMapping, wkz) || wkz,
                integrationParameters = IntegrationService.getIntegrationParams(),
                beitragsanpassungWechselMoeglichMessage,
                modalBeitragsanpassungWechselMoeglich,
                step,
                alerts = AlertService.get();

            $log.log('EinstiegController', vm, $element);

            IntegrationService.setIntegrationParams({
                angwkz: wkz ? wkz : integrationParameters.angwkz,
                angwkzname: wkzUrlMapping ? wkzUrlMapping : integrationParameters.angwkzname
            });
            if (MiscUtilsService.isEmpty(_.get(angebotModel, 'angebot'))) {
                ExceptionHandlerService.logRemote(new Error('No angebot in angebotModel exists.'), true);

                return NavigationService.goToStep('fehler.404', {
                    reload: false
                });
            } else if (_.hasIn($stateParams, 'angwkzname') && MiscUtilsService.isEmpty(wkz) && integrationParameters.angmodus !== 'ersatz') {
                ExceptionHandlerService.logRemote(new Error('WKZ not exists.'), true);

                return NavigationService.goToStep('fehler.404', {
                    reload: false,
                    message: [
                        'Sie haben den Tarifrechner ohne die Auswahl eines Fahrzeuges aufgerufen.',
                        'Bitte besuchen Sie die Seite <a href="' + AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt + '" target="_self">' + _.replace(AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt, /http(s)?:\/\//gi, '') + '</a> und wählen Sie Ihr korrektes Fahrzeug aus.<br><hr class="spacer-small">',
                        'Sollten weiterhin Probleme auftreten können Sie sich gerne an uns wenden.'
                    ].join(' '),
                    links: {
                        tarifrechner: false
                    }
                });
            }

            if (MiscUtilsService.isAppModus()) {
                $element.parent().addClass('app-modus');
            }

            AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');
            step = BasisAngebotService.getStartStep(angebotModel.angebot, null, $stateParams);

            NavigationService.set(AngebotSpezifischService.getSteps(angebotModel.angebot));
            NavigationService.setPreviousDisabled(false, step);

            if (_.get(angebotModel.angebot, 'vertragsnummerErsatzgeschaeft.id')) {
                $analytics.eventTrack('lead', {
                    trackingProvider: 'wgv',
                    target: 'vertragsnummerErsatzgeschaeft',
                    value: _.get(angebotModel.angebot, 'vertragsnummerErsatzgeschaeft.id'),
                    state: 'unchangeable'
                });
            } else if (_.get(angebotModel.angebot, 'angebotsnummer.id')) {
                $analytics.eventTrack('lead', {
                    trackingProvider: 'wgv',
                    target: 'angebotLaden',
                    value: _.get(angebotModel.angebot, 'angebotsnummer.id'),
                    state: 'unchangeable'
                });
            }

            beitragsanpassungWechselMoeglichMessage = BasisAngebotService.getBeitragsanpassungMessage('BEITRAGSANPASSUNG_WECHSEL_MOEGLICH');

            if (beitragsanpassungWechselMoeglichMessage) {
                modalBeitragsanpassungWechselMoeglich = $modal.open({
                    templateUrl: 'modal/modalYesNo.html',
                    windowClass: 'medium',
                    controller: 'ModalYesNoController',
                    controllerAs: 'modalVm',
                    resolve: { /* @ngInject */
                        content: [function () {
                            return {
                                header: beitragsanpassungWechselMoeglichMessage.title,
                                body: beitragsanpassungWechselMoeglichMessage.message
                            };
                        }],
                        options: [function () {
                            return {};
                        }]
                    }
                });

                modalBeitragsanpassungWechselMoeglich.result.then(function () {
                    LoadingIndicatorService.addInProgress();

                    return BasisAngebotService.beitragsanpassung(angebotModel, 'akzeptieren').then(function (data) {
                        $log.debug('beitragsanpassung akzeptieren SUCCESS', data);

                        if (data.angebot) {
                            angebotModel.angebot = angular.merge({}, data.angebot);
                        }
                    }).catch(function (error) {
                        $log.debug('beitragsanpassung akzeptieren FAILURE', error);
                    }).finally(function () {
                        LoadingIndicatorService.removeInProgress();
                    });
                }).catch(function () {
                    LoadingIndicatorService.addInProgress();

                    return BasisAngebotService.beitragsanpassung(angebotModel, 'ablehnen').then(function (data) {
                        $log.debug('beitragsanpassung ablehnen SUCCESS', data);

                        if (data.angebot) {
                            angebotModel.angebot = angular.merge({}, data.angebot);
                        }
                    }).catch(function (error) {
                        $log.debug('beitragsanpassung ablehnen FAILURE', error);
                    }).finally(function () {
                        LoadingIndicatorService.removeInProgress();
                    });
                });
            }

            NavigationService.goToStep(step, {
                angwkzname: wkzUrlMapping,
                angwkz: wkz,
                init: false,
                alerts: alerts,
                berechnen: step === 'rechner.ergebnis' ? false : true
            }, {
                location: 'replace',
                reload: step,
                notify: true,
                supercede: false
            }, true);
        }
    }
})();
